import React from 'react';
import { Link } from 'react-router-dom';

/**
 * Contextual "go deeper" link — threads a home-page teaser section to its full
 * page (Jarvis, 2026-08-11: put the link in the context; don't make people hunt
 * the hamburger). Quiet by design — one per section, gold dashed underline, a
 * trailing arrow — reusing the site's existing arrow-link language. Pattern-setter
 * first use: MacroBalanced → Nutrition.
 */
export function SectionLink({ to, children }: { to: string; children: React.ReactNode }) {
  return (
    <div className="section-link-row">
      <Link className="section-link" to={to}>
        {children} <span aria-hidden="true">&rarr;</span>
      </Link>
    </div>
  );
}
